// SAD-1005: Waiting on You is one read, ListMyWork (slice 3): ryugu reads each
// source the way its own page reads it (the caller's delivery queue, its
// assigned actions, its pursuit work, what was shared with it), authorizes
// each, ranks them by one rule and counts every kind. One request, whatever
// the number of programs or pursuits.
import { ContractModelServiceTypes } from '@mono/proto-clients';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { contractModelClient, morgansClient } from '../../lib/connect/clients';
import { fromMyWorkItem } from './myWork';
export const MY_WORK_KEY = 'my-work';
/** The sources ListMyWork names in partial_kinds, in words. */ const SOURCE_WORDS = {
    delivery: 'Deliverables, approvals and requests',
    assigned: 'Corrections and issues assigned to you',
    pursuits: 'Pursuit decisions and tasks',
    shared: 'Items shared with you'
};
export function useMyWork(today) {
    const query = useQuery({
        queryKey: [
            MY_WORK_KEY,
            today
        ],
        queryFn: async ()=>{
            const resp = await contractModelClient.listMyWork({
                asOf: today,
                limit: 100
            });
            return new ContractModelServiceTypes.ListMyWorkResponse(resp);
        },
        staleTime: 30000,
        retry: 1
    });
    return useMemo(()=>{
        const data = query.data;
        const ranked = [];
        for (const it of data?.items ?? []){
            const w = fromMyWorkItem(it, today);
            if (w) ranked.push(w);
        }
        const failed = query.isError ? [
            'Waiting on You'
        ] : (data?.partialKinds ?? []).map((k)=>SOURCE_WORDS[k] ?? k);
        return {
            ranked,
            total: data?.total ?? 0,
            overdue: data?.overdue ?? 0,
            agendaDays: data?.agendaDays ?? [],
            isLoading: query.isLoading,
            failed,
            retry: ()=>void query.refetch(),
            today
        };
    }, [
        query,
        today
    ]);
}
export const PURSUIT_PIPELINE_KEY = 'pursuit-pipeline';
/**
 * SAD-1005 slice 4: Pursuits by stage and Decisions due, one read for the
 * pursuits the viewer can see (the capture room's own access), in the
 * Dashboard's scope.
 */ export function usePursuitPipeline(scope, today) {
    return useQuery({
        queryKey: [
            PURSUIT_PIPELINE_KEY,
            scope,
            today
        ],
        queryFn: async ()=>{
            const resp = await contractModelClient.getPursuitPipeline({
                scope,
                asOf: today
            });
            return new ContractModelServiceTypes.GetPursuitPipelineResponse(resp);
        },
        staleTime: 30000,
        retry: 1
    });
}
export const MY_MATCH_STATS_KEY = 'my-match-stats';
/** SAD-1005 slice 5: New matches, one call across the viewer's tracking profiles. */ export function useMyMatchStats() {
    return useQuery({
        queryKey: [
            MY_MATCH_STATS_KEY
        ],
        queryFn: ()=>morgansClient.getMyMatchStats({}),
        staleTime: 60000,
        retry: 1
    });
}
